import { styled, Typography } from '@mui/material';

export const VoucherDrawerLabel = styled(Typography)`
    font-size: 0.9rem;
`;
